import { GatewayControleQuinquennal } from "@conformite/gateway";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { ControleQuinquennalApi } from "../controle-quinquennal.api";
import { controleQuinquennalKeys } from "./controle-quinquennal.keys";

export const useCQListQuery = (
  params: GatewayControleQuinquennal.ControleQuinquennalAdminSearchRequestType
) => {
  return useQuery({
    queryKey: controleQuinquennalKeys.list(params),
    queryFn: () => ControleQuinquennalApi.list(params),
    placeholderData: keepPreviousData,
    staleTime: Infinity,
  });
};
